import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
} from "..";

import "./styles.css";

const Counselor = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [counselors, setCounselors] = useState([
    {
      name: "",
      email: "",
      phone: "",
    },
  ]);

  useEffect(() => {
    setCounselors(
      questionnaire?.counselors?.length > 0
        ? questionnaire?.counselors
        : [
            {
              name: "",
              email: "",
              phone: "",
            },
          ]
    );
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      {counselors?.map((counselor, index) => (
        <div className={`${index > 0 ? "mt-6" : ""} `}>
          <div className="section-header">Counselor {index + 1}</div>
          <div className="grid grid-cols-2 gap-x-7 gap-y-6" key={index}>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Name"
                required
              />
              <Spacer height="0.3125em" />
              <questionnaireComponents.QuestionnaireValueBox
                value={counselor?.name}
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Email" />
              <Spacer height="0.3125em" />
              <questionnaireComponents.QuestionnaireValueBox
                value={counselor?.email}
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Phone Number" />
              <Spacer height="0.3125em" />
              <inputFields.DefaultPhoneInput
                disabled
                value={counselor?.phone}
              />
            </div>
          </div>
        </div>
      ))}

      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Extra-Curricular Activities")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Counselor;
